import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SmsOptIn() {
  const { businessId } = useParams();
  const [biz, setBiz] = useState(null);

  useEffect(() => {
    fetch(`${API}/public/sms-optin/${businessId}`).then((r) => r.json()).then(setBiz).catch(() => {});
  }, [businessId]);

  const name = biz?.business_name || 'This business';
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="sms-optin-page">
      <div className="max-w-2xl mx-auto bg-white border border-slate-200 rounded-xl p-8 space-y-5 text-slate-700">
        <h1 className="text-3xl font-bold text-slate-900">{name} Text Message Program</h1>
        <p>{name} uses Front Desk Pro, a Pro phone receptionist, to answer calls and schedule appointments.</p>
        <h2 className="text-lg font-semibold text-slate-900">How customers opt in</h2>
        <p>Customers opt in verbally during a phone call to {name}{biz?.ai_phone_number ? ` (${biz.ai_phone_number})` : ''}. When an appointment is booked or requested, the receptionist asks:</p>
        <blockquote className="border-l-4 border-blue-600 pl-4 italic text-slate-800">
          "Would you like text updates about your appointment? Message and data rates may apply, and you can reply STOP anytime."
        </blockquote>
        <p>Texts are only sent if the caller says yes. The opt-in is recorded with the call.</p>
        <h2 className="text-lg font-semibold text-slate-900">What we send</h2>
        <p>Appointment confirmations and reminders. No marketing. Example: "{name}: Your appointment is confirmed for Tue, Jun 9 at 2:00 PM. Reply STOP to opt out, HELP for help."</p>
        <p>Reply <b>STOP</b> to opt out or <b>HELP</b> for help. Message frequency varies. Message and data rates may apply. Mobile numbers and opt-in data are never sold or shared with third parties for marketing.</p>
        <p className="text-sm"><a href="/privacy" className="text-blue-600">Privacy Policy</a> · <a href="/terms" className="text-blue-600">Terms</a></p>
      </div>
    </div>
  );
}
